var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkGreen = function SvgCheckmarkGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#318500",
    fillRule: "evenodd",
    d: "M1.667 10c0-4.592 3.742-8.333 8.333-8.333S18.334 5.408 18.334 10 14.592 18.333 10 18.333 1.667 14.592 1.667 10m1.667 0A6.676 6.676 0 0 0 10 16.666 6.676 6.676 0 0 0 16.667 10 6.676 6.676 0 0 0 10 3.333 6.676 6.676 0 0 0 3.334 10m3.691-1.317L9.3 10.95l3.9-3.9 1.175 1.183L9.3 13.308l-3.45-3.45z",
    clipRule: "evenodd"
  })));
};
export { SvgCheckmarkGreen as Icon };
export default __webpack_public_path__ + "static/media/fef15cbcf683cdf8a5e71be854ab0eba.svg";